import { useFormSubmit } from "@/hooks/useFormSubmit";

export default function NewsletterForm() {
  const { status, error, successMessage, submit } = useFormSubmit({
    submitAddr: "https://readdy.ai/api/form/dah6jproh653ivfvnmdg",
    successMessage: "订阅成功，深夜速递会在每周三发出。",
  });

  return (
    <form
      id="newsletter-subscribe"
      data-readdy-form
      onSubmit={submit}
      className="w-full max-w-md"
      noValidate
    >
      <div className="flex flex-col gap-3 sm:flex-row">
        <label className="sr-only" htmlFor="newsletter-email">
          邮箱地址
        </label>
        <input
          id="newsletter-email"
          name="email"
          type="email"
          required
          autoComplete="email"
          placeholder="输入邮箱，订阅深夜速递"
          className="w-full flex-1 rounded-md border border-primary-800/70 bg-primary-950/60 px-4 py-2.5 text-sm text-foreground-950 placeholder:text-foreground-500 outline-none transition-colors duration-200 focus:border-accent-400"
        />
        <input
          type="text"
          name="website_alt"
          className="form-verify-alt-field"
          tabIndex={-1}
          autoComplete="off"
          aria-hidden="true"
          readOnly
        />
        <button
          type="submit"
          disabled={status === "submitting"}
          className="whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-medium text-background-950 transition-colors duration-200 hover:bg-accent-400 disabled:opacity-60 cursor-pointer"
        >
          {status === "submitting" ? "提交中…" : "订阅"}
        </button>
      </div>

      {status === "success" && (
        <p className="mt-3 flex items-center gap-2 text-xs text-secondary-300">
          <i className="ri-checkbox-circle-line text-base" />
          {successMessage}
        </p>
      )}
      {status === "error" && (
        <p className="mt-3 flex items-center gap-2 text-xs text-primary-300">
          <i className="ri-error-warning-line text-base" />
          {error}
        </p>
      )}
      {status === "idle" && (
        <p className="mt-3 text-xs text-foreground-500">
          每周三一封，只发复盘与时间线更新，随时可退订。
        </p>
      )}
    </form>
  );
}